/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Loader } from '../../../core/components/loader';
import { RoutePageProps } from '../../../core/routing';
import { Menu } from '../components/menu';
import { simulatorMenuItems } from '../config/menu';

import '../../../assets/styles/simulator.scss';

const SimulatorLayout: React.FC<RoutePageProps> = ({ route }: RoutePageProps): React.ReactElement => {
  if (route === null || route === undefined) {
    return <Redirect to="/" />;
  }

  return (
    <div className="app">
      {route.topBar && <Menu items={simulatorMenuItems} />}
      <div className="app-body">
        <main className="main">
          <Loader>
            <route.page {...route} />
          </Loader>
        </main>
      </div>
    </div>
  );
};

export default SimulatorLayout;
